'use strict';
/**
 * @author Romatel
 */
export default ['$resource', function($resource) {
    return $resource('api/supporttype/:typeId', { typeId: "@id"}, {
        getAll: {method: 'GET', isArray: true},
        get: {method: 'GET'},
        create: {url: 'api/supporttype', method: 'POST'},
        update: {url: 'api/supporttype/:typeId', method: 'PUT'},
        delete: {url: 'api/supporttype/:typeId', method: 'DELETE'},
    });
}];
